<template>
    <div>
        <bc-circle-loader v-if="loading == true"></bc-circle-loader>
        <v-container v-else fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ quote.quote_id ? $t("lang.edit_quote") : $t("lang.add_quote") }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="quote.quote_id && quote.quote_id > 0" @invoke-method="dbGetQuote(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="quote.quote_id && quote.quote_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print Estimate</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile v-if="current_user.slug != 'customer'" @click="setEmailDialog()">
                                    <v-list-tile-title>Email Estimate</v-list-tile-title>
                                    <v-divider class="ml-3 my-0"></v-divider>
                                </v-list-tile>
                                <v-list-tile v-if="current_user.slug == 'employee' && quote.status_id != 23" @click="approveEstimate()">
                                    <v-list-tile-title>Approve Estimate</v-list-tile-title>
                                    <v-divider class="ml-3 my-0"></v-divider>
                                </v-list-tile>

                                <v-list-tile
                                    @click="convertToOrder()"
                                    v-if="(quote.status_id == 22 || quote.status_id == 23) && current_user.slug != 'customer'"
                                >
                                    <v-list-tile-title> Convert to Order </v-list-tile-title>
                                </v-list-tile>
                                <!--<template v-if="hasPerm('quotes.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in quote_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != quote.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
									<v-divider class="ml-3 my-0"></v-divider>
                                </template>-->

                                <v-list-tile v-if="current_user.slug != 'customer'" @click="flipCurrency">
                                    <v-list-tile-title v-if="convert_currency">View as Company</v-list-tile-title>
                                    <v-list-tile-title v-else>View as Customer</v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('quotes.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_quote.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'quotes' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-container fluid grid-list-xl :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <bc-transaction-links :items="quote.transaction_links" :object_id="quote.quote_id"></bc-transaction-links>
                    <v-flex :class="quote.quote_id != null ? 'lg10 md9 xs12' : 'lg12 md12 xs12'" pb-0 mb-0>
                        <v-card elevation="0">
                            <v-card-text :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                                <div v-if="quote.status" class="ribbon ribbon-top-right" :class="`ribbon-${quote.status_class}`">
                                    <span class="ribbon-span">{{ quote.status }}</span>
                                </div>

                                <vue-perfect-scrollbar
                                    class="scroll-area"
                                    :style="$bp.xs ? null : 'max-height: calc(100vh - 260px); min-height: calc(100vh - 260px)'"
                                >
                                    <v-form ref="formQuote">
                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                            <v-flex xs12 sm6 row-2-fr1>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12>
                                                        <bc-autocomplete
                                                            v-if="quote.status_id != 170"
                                                            v-model="quote.company_id"
                                                            :label="`${$t('lang.company_id')} *`"
                                                            :items="filter_customer_options"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('quotes.company_id')"
                                                            @change="selectCustomer(quote.company_id)"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                        <bc-autocomplete
                                                            v-else
                                                            v-model="quote.company_id"
                                                            :label="`${$t('lang.company_id')} *`"
                                                            :items="filter_customer_options"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            append-icon="lock"
                                                            disabled
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <div
                                                            class="customer-address"
                                                            v-if="quote.billing_address_id != null"
                                                            style="padding: 0px 12px 12px 12px"
                                                        >
                                                            <h3>
                                                                {{ $t("lang.billing_address_id") }}
                                                                <v-btn
                                                                    v-if="quote.status_id != 170"
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('bill_address')"
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn>
                                                            </h3>
                                                            <div>
                                                                <div v-if="quote.bill_location_label">
                                                                    {{ quote.bill_location_label }}
                                                                </div>
                                                                <div>
                                                                    {{ quote.bill_address1 }}
                                                                </div>
                                                                <div v-if="quote.bill_address2 != ''">
                                                                    {{ quote.bill_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ quote.bill_city }}, {{ quote.bill_state }},
                                                                    {{ quote.bill_zip_code }}
                                                                </div>
                                                                <div>
                                                                    {{ quote.bill_country_iso_3 }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <div
                                                            class="customer-address"
                                                            v-if="quote.shipping_address_id != null"
                                                            style="padding: 0px 12px 12px 12px"
                                                        >
                                                            <h3>
                                                                {{ $t("lang.shipping_address_id") }}
                                                                <v-btn
                                                                    v-if="quote.status_id != 170"
                                                                    color="secondary"
                                                                    icon
                                                                    small
                                                                    @mouseup.left="changeAddress('ship_address')"
                                                                >
                                                                    <v-icon small>edit</v-icon>
                                                                </v-btn>
                                                            </h3>
                                                            <div>
                                                                <div v-if="quote.ship_location_label">
                                                                    {{ quote.ship_location_label }}
                                                                </div>
                                                                <div>
                                                                    {{ quote.ship_address1 }}
                                                                </div>
                                                                <div v-if="quote.ship_address2 != ''">
                                                                    {{ quote.ship_address2 }}
                                                                </div>
                                                                <div>
                                                                    {{ quote.ship_city }}, {{ quote.ship_state }},
                                                                    {{ quote.ship_zip_code }}
                                                                </div>
                                                                <div>
                                                                    {{ quote.ship_country_iso_3 }}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm6>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-if="quote.quote_id"
                                                        v-model="quote.quote_id"
                                                        :label="$t('lang.quote_id')"
                                                        :counter="showCounter(quote.quote_id, 'quotes.quote_id')"
                                                        :rules="ifValid('quotes.quote_id')"
                                                        disabled
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-model="quote.quote_date"
                                                            :label="$t('lang.quote_date')"
                                                            :rules="ifValid('quotes.quote_date')"
                                                            :is_disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <bc-date-picker
                                                            v-model="quote.expire_date"
                                                            :label="$t('lang.expire_date')"
                                                            :rules="ifValid('quotes.expire_date')"
                                                            :is_disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="quote.payment_term_id"
                                                            :label="`${$t('lang.payment_term')} *`"
                                                            :items="filter_payment_terms"
                                                            item-value="payment_term_id"
                                                            item-text="description"
                                                            :rules="ifValid('quotes.payment_term_id')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-if="current_user.login_type_id == '1'"
                                                            v-model="quote.quoted_by_id"
                                                            :label="$t('lang.quoted_by_id')"
                                                            :items="people"
                                                            item-value="user_id"
                                                            item-text="combined_name"
                                                            :rules="ifValid('quotes.quoted_by_id')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                        <v-text-field v-else v-model="quote.quoted_by" :label="$t('lang.quoted_by_id')" disabled></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="quote.shipping_carrier_id"
                                                            :label="$t('lang.shipping_carrier_id')"
                                                            :items="filter_shipping_carriers"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('quotes.shipping_carrier_id')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="quote.freight_term_id"
                                                            :label="$t('lang.freight_term_id')"
                                                            :items="filter_freight_terms"
                                                            item-value="option_id"
                                                            item-text="option"
                                                            :rules="ifValid('quotes.freight_term_id')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout
                                                    row
                                                    wrap
                                                    :class="$bp.smallScreen ? 'mx-0' : null"
                                                    style="margin: 0px"
                                                    v-if="current_user.login_type_id != '2'"
                                                >
                                                    <v-flex xs12 sm6>
                                                        <bc-autocomplete
                                                            v-model="quote.currency_id"
                                                            :label="$t('lang.document_currency')"
                                                            :items="filter_currencies"
                                                            item-value="currency_id"
                                                            item-text="name"
                                                            :rules="ifValid('quotes.currency_id')"
                                                            @change="setExchangeRate(quote.currency_id)"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="quote.exchange_rate"
                                                            :label="$t('lang.exchange_rate')"
                                                            :counter="showCounter(quote.exchange_rate, 'quotes.exchange_rate')"
                                                            :rules="ifValid('quotes.exchange_rate')"
                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                                <v-flex xs12 v-if="current_user.login_type_id == '1'">
                                                    <bc-autocomplete
                                                        v-model="quote.project_id"
                                                        :label="`${$t('lang.project')}`"
                                                        :items="projects"
                                                        item-value="project_id"
                                                        item-text="project_name"
                                                        :rules="ifValid('quotes.project_id')"
                                                    ></bc-autocomplete>
                                                </v-flex>
                                            </v-flex>
                                        </v-layout>
                                        <div>
                                            <v-data-table
                                                :headers="quote_headers"
                                                :items="quote.quote_details || []"
                                                item-key="quote_detail_id"
                                                :no-data-text="$t('lang.no_results_matching')"
                                                hide-actions
                                                class="custom-table"
                                            >
                                                <template slot="items" slot-scope="props">
                                                    <tr>
                                                        <td>
                                                            <!-- <bc-autocomplete
                                                                v-model="props.item.part_id"
                                                                :items="filter_fe_part_options(props.item)"
                                                                item-value="part_id"
                                                                item-text="sales_sku"
                                                                @change="handleChangePart(props.index, props.item.part_id)"
                                                                :rules="ifValid('quotes.quote_details.part_id')"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></bc-autocomplete> -->
                                                            <div>
                                                                <v-progress-circular
                                                                    v-if="
                                                                        props.item.part_id != null && (props.item.name == null || props.item.name == undefined)
                                                                    "
                                                                    indeterminate
                                                                    color="primary"
                                                                ></v-progress-circular>
                                                            </div>
                                                            <bc-autocomplete
                                                                v-if="props.item.part_id == null"
                                                                v-model="props.item.part_id"
                                                                :items="filter_fe_part_options(props.item)"
                                                                item-value="part_id"
                                                                item-text="sales_sku"
                                                                @change="handleChangePart(props.index, props.item.part_id)"
                                                                :rules="ifValid('quotes.quote_details.part_id')"
                                                                :append-icon="current_user.login_type_id != '1' ? 'lock' : 'arrow_drop_down'"
                                                                :disabled="current_user.login_type_id != '1' ? true : false"
                                                                :filter="$filterFePartsSales"
                                                                :ref="`${props.index}_quote_detail_id`"
                                                            >
                                                                <template slot="item" slot-scope="data">
                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title
                                                                            ><strong>{{ data.item.sales_sku }}</strong></v-list-tile-title
                                                                        >
                                                                        <v-list-tile-sub-title v-html="data.item.name"></v-list-tile-sub-title>
                                                                        <v-list-tile-sub-title v-html="data.item.model_number"></v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </template>
                                                            </bc-autocomplete>
                                                            <v-list-tile
                                                                v-if="props.item.name != null || props.item.name != undefined"
                                                                class="full-height-tile"
                                                            >
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title
                                                                        ><strong>{{ props.item.sales_sku || props.item.sku }}</strong></v-list-tile-title
                                                                    >
                                                                    <v-list-tile-sub-title>{{ `Name: ${props.item.name}` }}</v-list-tile-sub-title>
                                                                    <v-list-tile-sub-title>{{ `Model: ${props.item.model_number}` }}</v-list-tile-sub-title>
                                                                </v-list-tile-content>
                                                                <v-list-tile-action style="position: absolute; top: 0px; right: 0px; align-items: normal">
                                                                    <v-btn icon ripple @click="resetLine(props.index, props.item)">
                                                                        <v-icon color="grey lighten-1">cancel</v-icon>
                                                                    </v-btn>
                                                                </v-list-tile-action>
                                                            </v-list-tile>
                                                        </td>
                                                        <td>
                                                            <v-text-field v-model="props.item.hts_code" disabled></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.quantity"
                                                                :counter="showCounter(props.item.quantity, 'quotes.quote_details.quantity')"
                                                                :rules="ifValid('quotes.quote_details.quantity')"
                                                                :ref="`${props.index}_quantity`"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <bc-autocomplete
                                                                v-model="props.item.sales_unit"
                                                                :items="filter_sales_units(props.item)"
                                                                item-value="option_id"
                                                                item-text="option"
                                                                :rules="ifValid('quotes.quote_details.sales_unit')"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></bc-autocomplete>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                v-model="props.item.lead_time"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                        </td>
                                                        <td v-if="current_user.slug != 'customer'">
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && quote.currency_prefix != null ? quote.currency_prefix : '$'
                                                                "
                                                                :suffix="convert_currency == true && quote.currency_suffix != null ? quote.currency_suffix : ''"
                                                                v-model="props.item.cost_price"
                                                                :counter="showCounter(props.item.cost_price, 'quotes.quote_details.cost_price')"
                                                                :rules="ifValid('quotes.quote_details.cost_price')"
                                                            ></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && quote.currency_prefix != null ? quote.currency_prefix : '$'
                                                                "
                                                                :suffix="convert_currency == true && quote.currency_suffix != null ? quote.currency_suffix : ''"
                                                                v-model="props.item.unit_price"
                                                                :counter="showCounter(props.item.unit_price, 'quotes.quote_details.unit_price')"
                                                                :rules="ifValid('quotes.quote_details.unit_price')"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                        </td>
                                                        <td style="display: flex">
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-if="props.item.line_discount_type == 'P'"
                                                                v-model="props.item.line_discount_percentage"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                            <v-text-field
                                                                class="pr-3"
                                                                v-else-if="props.item.line_discount_type == 'A'"
                                                                v-model="props.item.line_discount_amount"
                                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                            ></v-text-field>
                                                            <v-btn
                                                                v-if="current_user.slug != 'customer'"
                                                                x-small
                                                                raised
                                                                class="ma-0 pa-0"
                                                                style="min-width: 24px !important"
                                                                @click="setDetailDiscount(props.index)"
                                                            >
                                                                {{
                                                                    convert_currency == true
                                                                        ? quote.currency_prefix != null && props.item.line_discount_type == "A"
                                                                            ? quote.currency_prefix
                                                                            : "%"
                                                                        : props.item.line_discount_type == "P"
                                                                        ? "%"
                                                                        : "$"
                                                                }}
                                                            </v-btn>
                                                        </td>
                                                        <td>
                                                            <v-text-field
                                                                :prefix="
                                                                    convert_currency == true && quote.currency_prefix != null ? quote.currency_prefix : '$'
                                                                "
                                                                :suffix="convert_currency == true && quote.currency_suffix != null ? quote.currency_suffix : ''"
                                                                v-model="props.item.line_total"
                                                                disabled
                                                            ></v-text-field>
                                                        </td>
                                                        <td v-if="quote.status_id != 170 && current_user.slug != 'customer'">
                                                            <v-icon @click="removeRow(props.index)">delete</v-icon>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </div>

                                        <v-card class="mx-auto mb-4" elevation="0">
                                            <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                    <v-flex xs12 sm8>
                                                        <v-container fluid class="pa-0">
                                                            <v-btn
                                                                v-if="quote.status_id != 170 && current_user.slug != 'customer'"
                                                                x-small
                                                                raised
                                                                color="primary"
                                                                @click="addRow()"
                                                                >{{ $t("lang.add_more") }}</v-btn
                                                            >
                                                        </v-container>
                                                    </v-flex>
                                                    <v-flex xs12 sm4>
                                                        <table style="width: 100%">
                                                            <tbody>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">
                                                                        {{ $t("lang.subtotal") }}
                                                                    </th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && quote.currency_prefix != null
                                                                                    ? quote.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && quote.currency_suffix != null
                                                                                    ? quote.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="quote.subtotal"
                                                                            :counter="showCounter(quote.subtotal, 'quotes.subtotal')"
                                                                            disabled
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.discount") }}</th>
                                                                    <td>
                                                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                                            <v-flex xs11 :class="$bp.smallScreen ? 'pl-0' : null" class="pr-3">
                                                                                <v-text-field
                                                                                    v-model="quote.discount"
                                                                                    :counter="showCounter(quote.discount, 'quotes.discount')"
                                                                                    :rules="ifValid('quotes.discount')"
                                                                                    :disabled="current_user.slug == 'customer' ? true : false"
                                                                                ></v-text-field>
                                                                            </v-flex>
                                                                            <v-flex xs1 class="pl-0" v-if="current_user.slug != 'customer'">
                                                                                <v-container fluid class="pa-0">
                                                                                    <v-btn
                                                                                        class="ma-0 pa-0"
                                                                                        x-small
                                                                                        raised
                                                                                        style="min-width: 25px !important"
                                                                                        @click="setDiscount(quote.discount_type)"
                                                                                    >
                                                                                        {{
                                                                                            convert_currency == true
                                                                                                ? quote.currency_prefix != null && quote.discount_type == "A"
                                                                                                    ? quote.currency_prefix
                                                                                                    : "%"
                                                                                                : quote.discount_type == "P"
                                                                                                ? "%"
                                                                                                : "$"
                                                                                        }}
                                                                                    </v-btn>
                                                                                </v-container>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.freight") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && quote.currency_prefix != null
                                                                                    ? quote.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && quote.currency_suffix != null
                                                                                    ? quote.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="quote.freight"
                                                                            :counter="showCounter(quote.freight, 'quotes.freight')"
                                                                            :rules="ifValid('quotes.freight')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.customs") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && quote.currency_prefix != null
                                                                                    ? quote.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && quote.currency_suffix != null
                                                                                    ? quote.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="quote.customs"
                                                                            :counter="showCounter(quote.customs, 'quotes.customs')"
                                                                            :rules="ifValid('quotes.customs')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.expedite_fee") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && quote.currency_prefix != null
                                                                                    ? quote.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && quote.currency_suffix != null
                                                                                    ? quote.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="quote.expedite_fee"
                                                                            :counter="showCounter(quote.expedite_fee, 'quotes.expedite_fee')"
                                                                            :rules="ifValid('quotes.expedite_fee')"
                                                                            :disabled="current_user.slug == 'customer' ? true : false"
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.handling_charge") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && quote.currency_prefix != null
                                                                                    ? quote.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && quote.currency_suffix != null
                                                                                    ? quote.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="quote.handling_charge"
                                                                            :counter="showCounter(quote.handling_charge, 'quotes.handling_charge')"
                                                                            :rules="ifValid('quotes.handling_charge')"
                                                                            disabled
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th class="pr-4" style="text-align: right">{{ $t("lang.total_amount") }}</th>
                                                                    <td>
                                                                        <v-text-field
                                                                            :prefix="
                                                                                convert_currency == true && quote.currency_prefix != null
                                                                                    ? quote.currency_prefix
                                                                                    : '$'
                                                                            "
                                                                            :suffix="
                                                                                convert_currency == true && quote.currency_suffix != null
                                                                                    ? quote.currency_suffix
                                                                                    : ''
                                                                            "
                                                                            v-model="quote.total_amount"
                                                                            :counter="showCounter(quote.total_amount, 'quotes.total_amount')"
                                                                            disabled
                                                                        ></v-text-field>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>

                                        <v-flex xs12>
                                            <v-textarea
                                                v-model="quote.comments"
                                                :label="$t('lang.comments')"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('quotes.comments')"
                                                :disabled="current_user.slug == 'customer' ? true : false"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <bc-autocomplete
                                                v-model="quote.department_id"
                                                :label="$t('lang.department')"
                                                :items="department_options"
                                                item-value="department_id"
                                                item-text="department_name"
                                                :rules="ifValid('quotes.department_id')"
                                                :disabled="current_user.slug == 'customer' ? true : false"
                                                disabled
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-form>
                                </vue-perfect-scrollbar>
                            </v-card-text>
                            <v-card-actions v-if="!convert_currency">
                                <v-spacer></v-spacer>
                                <v-btn v-if="quote.status_id != 170" @mouseup.left="$router.push({ name: 'quotes' })" flat>{{ $t("lang.cancel") }}</v-btn>
                                <v-btn v-if="quote.status_id != 170 && current_user.slug != 'customer'" color="success" @click="saveQuotes">{{
                                    $t("lang.save")
                                }}</v-btn>
                            </v-card-actions>
                            <div v-else-if="convert_currency && current_user.slug != 'customer'" style="width: 100%" class="pa-0">
                                <v-alert style="width: 100%; padding: 12px !important" :value="true" type="warning" color="#f78c00">{{
                                    $t("lang.warn_viewing_as_customer")
                                }}</v-alert>
                            </div>
                            <v-card-actions v-else style="width: 100%" class="pa-0">
                                <v-spacer></v-spacer>
                                <v-btn v-if="quote.status_id != 170" @mouseup.left="$router.push({ name: 'quotes' })" flat>{{ $t("lang.cancel") }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <bc-modal-email ref="emailDialog" :pdfReportName="`quote_${quote.quote_id}.pdf`" :endPoint="`/quotes/${quote.quote_id}/email`"></bc-modal-email>

            <bc-address-selector ref="select_address_dialog" @eventname="updateAddress"></bc-address-selector>
            <delete-confirmation-dialog
                ref="delete_quote"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_quote')"
                :message="$t('lang.delete_quote_confirm')"
                @onConfirm="deleteQuotes()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_quote_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteQuoteDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import axios from "axios";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            quote_headers: [
                {
                    text: this.$t("lang.part_id"),
                    sortable: false,
                    width: "25%",
                },
                {
                    text: this.$t("lang.hts_code"),
                    sortable: false,
                    width: "5%",
                },
                {
                    text: this.$t("lang.quantity"),
                    sortable: false,
                    width: "6%",
                },
                {
                    text: this.$t("lang.sales_unit"),
                    sortable: false,
                    width: "10%",
                },
                {
                    text: this.$t("lang.lead_time"),
                    sortable: false,
                    width: "2.5%",
                },
                {
                    text: this.$t("lang.cost_price"),
                    sortable: false,
                    width: "7.5%",
                },
                {
                    text: this.$t("lang.unit_price"),
                    sortable: false,
                    width: "7.5%",
                },
                {
                    text: this.$t("lang.discount"),
                    sortable: false,
                    width: "10%",
                },
                {
                    text: this.$t("lang.line_total"),
                    sortable: false,
                    width: "10%",
                },
                { text: "", width: "3%", sortable: false },
            ],
            formData: {},
            quote: {
                expedite_fee: "0.000",
                handling_charge: "0.000",
                freight: "0.000",
                customs: "0.000",
                subtotal: "0.000",
                discount: "0.000",
                total_amount: "0.000",
                quote_details: [],
                billing_address_id: null,
                shipping_address_id: null,
                bill_address: null,
                ship_address: null,
                address_options: [],
                currency_id: "1",
                exchange_rate: "1.000000",
                discount_type: "A",
                currency_prefix: "$",
                currency_suffix: "",
                currency_precision: 3,
            },
            convert_currency: false,
            file_name: "",
            dbGetQuote: _.debounce(this.getQuote, 1500, {
                maxWait: 1500,
                leading: true,
                trailing: false,
            }),
            people: [],
            email_dialog: false,
            loading: true,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchQuote", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.quote) {
                        this.quote = this.assignObj2(data.quote, this.rules_quotes);
                        if (this.current_user.login_type_id == "2") this.flipCurrency();
                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=quote_status&sort_by=2",
                            method: "get",
                            stateProperty: "quote_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        this.refresh();
                        next();
                    } else {
                        next({ name: "quotes", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchQuote", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.quote) {
                        next((vm) => {
                            vm.quote = vm.assignObj2(data.quote, vm.rules_quotes);
                            if (vm.current_user.login_type_id == "2") vm.flipCurrency();
                            store.dispatch("fetchSetting", {
                                url: "options?slug=quote_status&sort_by=2",
                                method: "get",
                                stateProperty: "quote_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.$store.commit("toggleMainMenu", false);
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "quotes", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetOptions");
        this.$store.commit("resetPeople");
        this.$store.commit("resetCustomers");
        this.$store.commit("resetCurrencies");
        this.$store.commit("resetFeParts");
        this.$store.commit("resetPaymentTerms");
        this.$store.commit("resetDepartments");
        this.$store.commit("resetShippingCarriers");
        this.$store.commit("resetProjects");
        next();
    },
    computed: {
        ...mapState({
            rules_quotes: (state) => state.quotes.rules_quotes,
            quote_status_options: (state) => state.settings.quote_status_options,
            quotes: (state) => state.quotes.quotes,
            selectedQuote: (state) => state.quotes.selectedQuote,
            fe_part_options: (state) => state.fe_parts.fe_part_options,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carrier_options,
            department_options: (state) => state.departments.department_options,
            customer_options: (state) => state.customers.customer_options,
            freight_terms: (state) => state.options_categories.freight_terms,
            quote_status: (state) => state.options_categories.quote_status,
            sales_units: (state) => state.options_categories.sales_units,
            payment_terms: (state) => state.payment_terms.payment_term_options,
            currencies: (state) => state.currencies.currencies,
            projects: (state) => state.projects.project_options,
        }),
        filter_customer_options() {
            return this.customer_options.filter((record) => !record.date_deleted || record.company_id === this.quote.company_id);
        },
        filter_freight_terms() {
            return this.freight_terms.filter((record) => !record.date_deleted || record.option_id === this.quote.freight_term_id);
        },
        filter_shipping_carriers() {
            return this.shipping_carriers.filter((record) => !record.date_deleted || record.company_id === this.quote.shipping_carrier_id);
        },
        filter_currencies() {
            return this.currencies.filter((record) => !record.date_deleted || record.currency_id === this.quote.currency_id);
        },
        filter_fe_part_options: function () {
            return function (item) {
                return this.fe_part_options.filter((record) => !record.date_deleted || record.part_id === item.part_id);
            };
        },
        filter_sales_units: function () {
            return function (item) {
                return this.sales_units.filter((record) => !record.date_deleted || record.option_id === item.sales_unit);
            };
        },
        filter_payment_terms() {
            return this.payment_terms.filter((record) => !record.date_deleted || record.option_id === this.quote.payment_term_id);
        },
        filter_department_options() {
            return this.department_options.filter((record) => !record.date_deleted || record.option_id === this.quote.department_option_id);
        },
    },
    watch: {
        quote: {
            handler: function (newValue) {
                if (!newValue.quote_details) newValue.quote_details = [];

                let subtotal = 0;
                for (let p of newValue.quote_details) {
                    if (p.line_discount_type == "A") {
                        p.line_total = (p.unit_price * p.quantity - p.line_discount_amount).toFixed(this.quote.currency_precision);
                        subtotal += parseFloat(p.line_total);
                    } else {
                        p.line_total = (p.unit_price * p.quantity - (p.unit_price * p.quantity * p.line_discount_percentage) / 100).toFixed(
                            this.quote.currency_precision
                        );
                        subtotal += parseFloat(p.line_total);
                    }
                }
                newValue.subtotal = subtotal.toFixed(this.quote.currency_precision);
                let total = subtotal;
                let discount = newValue.discount_type == "A" ? total - newValue.discount : total - (total * newValue.discount) / 100;
                total =
                    parseFloat(discount) +
                    parseFloat(newValue.expedite_fee) +
                    parseFloat(newValue.handling_charge) +
                    parseFloat(newValue.freight) +
                    parseFloat(newValue.customs);
                newValue.total_amount = total.toFixed(this.quote.currency_precision);
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions([
            "fetchQuote",
            "saveQuote",
            "deleteQuote",
            "printQuote",
            "fetchFeParts",
            "fetchCurrencies",
            "fetchShippingCarriers",
            "convertQuoteToPurchaseOrder",
            "convertQuoteToOrder",
            "fetchPaymentTerms",
            "fetchCustomers",
            "fetchDepartments",
            "fetchOptions",
            "fetchProjects",
            "fetchFePart",
            "fetchCustomer",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        addRow() {
            if (this.fe_part_options.length == 0) this.fetchFeParts({ body: { options: 1 } });
            if (!this.quote.quote_details) this.quote.quote_details = [];
            this.quote.quote_details.push({
                quote_id: `${this.$route.params.id}`,
                part_id: null,
                quantity: "1",
                cost_price: "0.000",
                unit_price: "0.000",
                line_discount_type: "P",
                line_discount_percentage: "0.000",
                line_discount_amount: "0.000",
                line_total: "0.000",
            });
        },
        removeRow: function (index) {
            if (this.fe_part_options.length == 0) this.fetchFeParts({ body: { options: 1 } });
            this.quote.quote_details.splice(index, 1);
        },
        changeAddress(type) {
            let address_list = this.quote.address_options ? this.quote.address_options : this.company.entity_addresses || [];
            this.$refs.select_address_dialog.showAddresses(address_list, type);
        },
        flipCurrency() {
            this.convert_currency = !this.convert_currency ? true : false;

            for (let p of this.quote.quote_details) {
                // if convert_currency is true, then convert the discount amount to the customer currency
                // calc cost_price, unit_price, line_discount_amount if amount
                if (this.convert_currency) {
                    p.cost_price = (p.cost_price * this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                    p.unit_price = (p.unit_price * this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                    if (p.line_discount_type == "A")
                        p.line_discount_amount = (p.line_discount_amount * this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                } else {
                    p.cost_price = (p.cost_price / this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                    p.unit_price = (p.unit_price / this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                    if (p.line_discount_type == "A")
                        p.line_discount_amount = (p.line_discount_amount / this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                }
            }
            // calc discount if amount, freight, customs, handling_charge, expedite_fee
            if (this.convert_currency) {
                if (this.quote.discount_type == "A")
                    this.quote.discount = (this.quote.discount * this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                this.quote.freight = (this.quote.freight * this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                this.quote.customs = (this.quote.customs * this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                this.quote.expedite_fee = (this.quote.expedite_fee * this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                this.quote.handling_charge = (this.quote.handling_charge * this.quote.exchange_rate).toFixed(this.quote.currency_precision);
            } else {
                if (this.quote.discount_type == "A")
                    this.quote.discount = (this.quote.discount / this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                this.quote.freight = (this.quote.freight / this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                this.quote.customs = (this.quote.customs / this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                this.quote.expedite_fee = (this.quote.expedite_fee / this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                this.quote.handling_charge = (this.quote.handling_charge / this.quote.exchange_rate).toFixed(this.quote.currency_precision);
            }
        },
        updateAddress(item, type) {
            if (type == "bill_address") {
                this.quote.billing_address_id = item.entity_addresses_id;
                this.quote.bill_location_label = item.location_label;
                this.quote.bill_address1 = item.address1;
                this.quote.bill_address2 = item.address2;
                this.quote.bill_city = item.city;
                this.quote.bill_state = item.state;
                this.quote.bill_zip_code = item.zip_code;
                this.quote.bill_zip_code_ext = item.zip_code_ext;
                this.quote.bill_country_iso_3 = item.country_iso_3;
            } else if (type == "ship_address") {
                this.quote.shipping_address_id = item.entity_addresses_id;
                this.quote.ship_location_label = item.location_label;
                this.quote.ship_address1 = item.address1;
                this.quote.ship_address2 = item.address2;
                this.quote.ship_city = item.city;
                this.quote.ship_state = item.state;
                this.quote.ship_zip_code = item.zip_code;
                this.quote.ship_zip_code_ext = item.zip_code_ext;
                this.quote.ship_country_iso_3 = item.country_iso_3;
            }
        },
        getQuote(pg_refresh = false) {
            this.startLoader();

            this.fetchQuote({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.quote) {
                    this.quote = this.assignObj2(data.quote, this.rules_quotes);
                    this.convert_currency = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        emailEstimate() {
            /*
                NEEDS COMPLETED
            */
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printQuote({
                id: `${this.$route.params.id}`,
                view_as: this.convert_currency,
            }).then((data) => {
                if (typeof data != "undefined" && data.quote) {
                    if (this.dev_mode) {
                        this.file_name = data.quote.file_name;
                    } else {
                        this.$refs.print.printReport(data.quote.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveQuotes() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formQuote")) {
                    let body = this.prepForm(this.quote, this.rules_quotes);

                    this.saveQuote({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.quote) {
                            this.quote = this.assignObj2(data.quote, this.rules_quotes);
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = {
                quote_id: `${this.$route.params.id}`,
                status_id: item.option_id,
            };

            this.saveQuote({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.quote) {
                    this.quote = this.assignObj2(data.quote, this.rules_quotes);
                    this.convert_currency = false;
                }
            });
        },
        deleteQuotes() {
            this.deleteQuote({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.delete_quote_details.close();
                    this.validationOff();
                    this.$router.push({ name: "quotes" });
                }
                this.toggleModalLoader(false);
            });
        },
        convertToOrder() {
            this.status_loader = true;
            let body = { quote_id: `${this.$route.params.id}` };

            this.convertQuoteToOrder({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.order) {
                    this.$router.push({ name: "order", params: { id: data.order.order_id } });
                }
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customer_options = data.companies;
                        this.getCustomerAddresses(this.quote.company_id);
                    }
                });
        },
        selectCustomer(company_id) {
            if (company_id == null) {
                return;
            } else {
                this.fetchCustomer({ id: company_id }).then((data) => {
                    if (data.customer) {
                        this.company = data.customer;

                        this.quote.currency_id = this.company.currency_id ? this.company.currency_id : 1;
                        this.quote.exchange_rate = this.company.exchange_rate ? this.company.exchange_rate : "1.000";

                        this.quote.address_options = this.company.entity_addresses ? this.company.entity_addresses : [];
                        let ship_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "shipping")[0] : null;
                        this.quote.ship_location_label = ship_address && ship_address.location_label ? ship_address.location_label : null;
                        this.quote.shipping_address_id = ship_address && ship_address.entity_addresses_id ? ship_address.entity_addresses_id : null;
                        this.quote.ship_address1 = ship_address && ship_address.address1 ? ship_address.address1 : null;
                        this.quote.ship_address2 = ship_address && ship_address.address2 ? ship_address.address2 : null;
                        this.quote.ship_city = ship_address && ship_address.city ? ship_address.city : null;
                        this.quote.ship_state = ship_address && ship_address.state ? ship_address.state : null;
                        this.quote.ship_zip_code = ship_address && ship_address.zip_code ? ship_address.zip_code : null;
                        this.quote.ship_zip_code_ext = ship_address && ship_address.zip_code_ext ? ship_address.zip_code_ext : null;
                        this.quote.ship_country_iso_3 = ship_address && ship_address.country_iso_3 ? ship_address.country_iso_3 : null;

                        let bill_address = this.company.entity_addresses ? this.company.entity_addresses.filter((x) => x.address_type == "billing")[0] : null;
                        this.quote.bill_location_label = bill_address && bill_address.location_label ? bill_address.location_label : null;
                        this.quote.billing_address_id = bill_address && bill_address.entity_addresses_id ? bill_address.entity_addresses_id : null;
                        this.quote.bill_address1 = bill_address && bill_address.address1 ? bill_address.address1 : null;
                        this.quote.bill_address2 = bill_address && bill_address.address2 ? bill_address.address2 : null;
                        this.quote.bill_city = bill_address && bill_address.city ? bill_address.city : null;
                        this.quote.bill_state = bill_address && bill_address.state ? bill_address.state : null;
                        this.quote.bill_zip_code = bill_address && bill_address.zip_code ? bill_address.zip_code : null;
                        this.quote.bill_zip_code_ext = bill_address && bill_address.zip_code_ext ? bill_address.zip_code_ext : null;
                        this.quote.bill_country_iso_3 = bill_address && bill_address.country_iso_3 ? bill_address.country_iso_3 : null;
                    } else {
                        return;
                    }
                });
            }
        },
        getParts() {
            this.fetchFeParts({
                body: {
                    options: 1,
                },
            }).then((data) => {
                if (typeof data !== "undefined") {
                    this.parts = data.fe_parts;
                }
            });
        },
        handleChangePart(index, part_id) {
            // Get the part from the parts array based on the part_id
            let partObj = this.fe_part_options.find((x) => x.part_id == part_id);
            this.fetchFePart({ id: partObj.part_id }).then((data) => {
                if (typeof data !== "undefined" && data.fe_part) {
                    partObj = data.fe_part;
                    if (this.convert_currency == true) {
                        this.quote.quote_details[index].cost_price = (partObj.preferred_vendor_unit_price * this.quote.exchange_rate).toFixed(
                            this.quote.currency_precision
                        );
                        this.quote.quote_details[index].unit_price = (partObj.sales_price * this.quote.exchange_rate).toFixed(this.quote.currency_precision);
                    } else {
                        this.quote.quote_details[index].cost_price = partObj.preferred_vendor_unit_price;
                        this.quote.quote_details[index].unit_price = partObj.sales_price;
                    }

                    this.quote.quote_details[index].model_number = partObj.model_number;
                    this.quote.quote_details[index].sales_unit = partObj.sales_unit;
                    this.quote.quote_details[index].name = partObj.name;
                    this.quote.quote_details[index].lead_time = partObj.preferred_vendor_lead_time;
                    this.quote.quote_details[index].hts_code = partObj.hts_code;
                    this.quote.quote_details[index].sales_sku = partObj.sales_sku;

                    this.$refs[`${index}_quantity`].$el.querySelector("input").focus();
                }
            });
        },
        resetLine(index, item) {
            this.quote.quote_details[index].part_id = null;
            this.quote.quote_details[index].cost_price = null;
            this.quote.quote_details[index].unit_price = null;
            this.quote.quote_details[index].model_number = null;
            this.quote.quote_details[index].sales_unit = null;
            this.quote.quote_details[index].name = null;
            this.quote.quote_details[index].lead_time = null;
            this.quote.quote_details[index].hts_code = null;
            this.quote.quote_details[index].sales_sku = null;

            this.$nextTick(() => {
                this.$refs[`${index}_quote_detail_id`].$children[0].focus();
                this.$refs[`${index}_quote_detail_id`].$children[0].isMenuActive = true;
            });
        },
        setDetailDiscount(index) {
            let part = this.quote.quote_details[index];
            if (part.line_discount_type == "P") {
                part.line_discount_type = "A";
                part.line_discount_amount = part.line_discount_percentage;
                part.line_discount_percentage = "0.000";
            } else {
                part.line_discount_type = "P";
                part.line_discount_percentage = part.line_discount_amount;
                part.line_discount_amount = "0.000";
            }
        },
        setDiscount() {
            this.quote.discount_type = this.quote.discount_type == "P" ? "A" : "P";
        },
        getPeople() {
            this.startLoader();

            this.$store
                .dispatch("fetchPeople", {
                    url: "people",
                    method: "get",
                    commit: true,
                    body: {
                        slug: "employee",
                        options: 1,
                    },
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    this.people = data.people;
                })
                .finally(() => {
                    this.finishLoader(false);
                });
        },
        setExchangeRate(currency_id) {
            let exchange_rate = this.currencies.find((x) => x.currency_id == currency_id);
            this.quote.currency_id = currency_id;
            this.quote.exchange_rate = exchange_rate.exchange_rate ? exchange_rate.exchange_rate : "1.000";
        },
        setEmailDialog() {
            this.validationOff();
            this.$refs.emailDialog.showEmail();
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchQuote({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.quote) {
                        this.quote = this.assignObj2(data.quote, this.rules_quotes);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            }

            if (this.people.length == 0) this.getPeople();

            if (this.quote.status_id == 170) {
                this.quote_headers.pop();
            } else {
                this.quote_headers = [
                    { text: this.$t("lang.part_id"), sortable: false, width: "25%" },
                    { text: this.$t("lang.hts_code"), sortable: false, width: "5%" },
                    { text: this.$t("lang.quantity"), sortable: false, width: "6%" },
                    { text: this.$t("lang.sales_unit"), sortable: false, width: "10%" },
                    { text: this.$t("lang.lead_time"), sortable: false, width: "2.5%" },
                    { text: this.$t("lang.cost_price"), sortable: false, width: "7.5%" },
                    { text: this.$t("lang.unit_price"), sortable: false, width: "7.5%" },
                    { text: this.$t("lang.discount"), sortable: false, width: "10%" },
                    { text: this.$t("lang.line_total"), sortable: false, width: "10%" },
                    { text: "", width: "3%", sortable: false },
                ];
            }
            if (this.current_user.slug == "customer") this.quote_headers.splice(6, 1);

            //if (this.customer_options.length == 0 || force == true)
            this.fetchCustomers({ body: { options: 1, with_trashed: this.quote.quote_id ? "1" : "0" } });

            if (this.currencies.length == 0 || force == true) this.fetchCurrencies({ body: { options: 1, with_trashed: this.quote.quote_id ? "1" : "0" } });
            //if (this.fe_part_options.length == 0 || force == true)
            this.fetchFeParts({ body: { options: 1, with_trashed: this.quote.quote_id ? "1" : "0" } });

            if (this.freight_terms == 0 || force == true)
                this.fetchOptions({ body: { slug: "freight_terms", with_trashed: this.quote.quote_id ? "1" : "0", options: 1 } });
            if (this.quote_status == 0 || force == true)
                this.fetchOptions({ body: { slug: "quote_status", with_trashed: this.quote.quote_id ? "1" : "0", options: 1 } });
            if (this.sales_units == 0 || force == true)
                this.fetchOptions({ body: { slug: "sales_units", sort_by: "0", with_trashed: this.quote.quote_id ? "1" : "0", options: 1 } });
            if (this.payment_terms.length == 0 || force == true)
                this.fetchPaymentTerms({ body: { options: 1, with_trashed: this.quote.quote_id ? "1" : "0" } });
            if (this.department_options.length == 0 || force == true)
                this.fetchDepartments({ body: { options: 1, with_trashed: this.quote.quote_id ? "1" : "0" } });

            if (!this.quote.department_id) this.quote.department_id = this.currUserField("department_id");
            if (!this.quote.quoted_by_id) this.quote.quoted_by_id = this.currUserField("user_id");
            if (this.quote.quote_date == null || force == true) {
                var quote_date = new Date();
                var expire_date = new Date();
                expire_date.setDate(quote_date.getDate() + 30);
                this.quote.quote_date = quote_date.toISOString().slice(0, 10);
                this.quote.expire_date = expire_date.toISOString().slice(0, 10);
            }

            if (this.shipping_carriers.length == 0 || force == true)
                this.fetchShippingCarriers({ body: { options: 1, with_trashed: this.quote.quote_id ? "1" : "0", department_id: "1" } });

            if (this.projects.length == 0 || force == true) await this.fetchProjects({ body: { options: 1 } });

            this.loading = false;
            this.finishLoader();
        },
        approveEstimate() {
            this.quote.status_id = "23";
            this.saveQuotes();
        },
    },
};
</script>
<style lang="css">
.custom-table .v-table tbody tr td {
    vertical-align: top !important;
}
</style>
